import React from "react";

import { StepProps } from "./types";
import { useStep } from "./hooks";

export const Step = (props: StepProps) => {
  const { getDecProps, getIncProps, getStepProps, getValueProps, values } =
    useStep(props);
  return (
    <div {...getStepProps()}>
      <button {...getDecProps()} />
      <button {...getValueProps()}>
        <span>
          {props.value} {values.balanceLabel}
        </span>
      </button>
      <button {...getIncProps()} />
    </div>
  );
};
